import React from "react";

const PayrollRatio = ({ row }) => {
  return <div>{row?.payrollRatio?.toLocaleString()}</div>;
};

export default PayrollRatio;
